
<form class="otp-section">
  <h2 *ngIf="caller.parent !== 'TWO_VERIFICATION'">To reset Password enter 4 digit pin
    sent to your registered mobile no {{str}}.</h2>
  <h2 *ngIf="caller.parent == 'TWO_VERIFICATION'">Enter the OTP sent to {{str}}.</h2>
  <div class="row">
    <div class="form-group">
      <input autofocus="autofocus" #pwd (blur)="typePassword()" [(ngModel)]="userPwd" [ngClass]="{'is-invalid':statusText2}" [ngModelOptions]="{standalone: true}"
             class="form-control text-center" id="password"
             placeholder="Enter Password" required type="password" style="font-size: 12px;">
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-3"><input type="text" onkeypress='return event.charCode >= 48 && event.charCode <= 57' appOnlyNumbers (keyup)="keytab($event, 'password2', 'password1')"  id="password1"   [ngClass]="{'is-invalid':errorMessage}" [(ngModel)]="password1"  class="form-control text-center" maxlength="1"  [ngModelOptions]="{standalone: true}" required></div>
    <div class="col-3"><input type="text" onkeypress='return event.charCode >= 48 && event.charCode <= 57' appOnlyNumbers (keyup)="keytab($event, 'password3', 'password1')" id="password2"  [ngClass]="{'is-invalid':errorMessage}" [(ngModel)]="password2"  class="form-control text-center" maxlength="1"  [ngModelOptions]="{standalone: true}" required></div>
    <div class="col-3"><input type="text" onkeypress='return event.charCode >= 48 && event.charCode <= 57' appOnlyNumbers (keyup)="keytab($event, 'password4', 'password2')" id="password3"  [ngClass]="{'is-invalid':errorMessage}" [(ngModel)]="password3"  class="form-control text-center" maxlength="1"  [ngModelOptions]="{standalone: true}" required></div>
    <div class="col-3"><input type="text" onkeypress='return event.charCode >= 48 && event.charCode <= 57' appOnlyNumbers (keyup)="keytab($event, 'password4', 'password3');verifyWebOtp()" id="password4"  [ngClass]="{'is-invalid':errorMessage}" [(ngModel)]="password4"  class="form-control text-center" maxlength="1"  [ngModelOptions]="{standalone: true}" required></div>
  </div>
  <div class="invalid-feedback d-block mb-3" [hidden]="!errorMessage">{{errorMessage}}</div>
  <div class="text-success invalid-feedback d-block mb-3" [hidden]="!successMessage">{{successMessage}}</div>
  <div class="row align-items-center mb-4 mt-3">
    <div class="offset-md-3 col-md-6">
      <button *ngIf="caller.parent == 'TWO_VERIFICATION'" (click)="verifyWebOtp()" class="btn btn-orange-prime btn-block">Verify</button>
      <button *ngIf="caller.parent == 'REGISTER'" (click)="verifyWebOtp()" class="btn btn-orange-prime btn-block">Verify</button>
      <button *ngIf="caller.parent == 'FORGOT_PASSWORD'" (click)="verifyFPOtp()" class="btn btn-orange-prime btn-block">Verify</button>
    </div>
  </div>

  <div class="text-orange mt-5">
    OTP expires in {{timerDisplayValue}} Minutes!
  </div>
  <div class="mt-2 forgot">
    <a (click)="submitResend()">Resend OTP</a>
  </div>

</form>

